"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = function _default(_ref) {
  var primaryColor = _ref.primaryColor,
      accentColor = _ref.accentColor,
      amountFilled = _ref.amountFilled,
      amountEmpty = _ref.amountEmpty;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40"
  }, /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "20",
    cy: "20",
    r: "12.7323954474",
    fill: "transparent",
    stroke: primaryColor,
    strokeWidth: "10"
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "20",
    cy: "20",
    r: "12.7323954474",
    fill: "transparent",
    stroke: accentColor,
    strokeWidth: "10",
    strokeDasharray: "".concat(amountFilled, " ").concat(amountEmpty),
    strokeDashoffset: "20"
  }));
};

exports["default"] = _default;